/** Canonical values for incomlend.roles.name — must match python-be RoleList. */
export const USER_ROLE_NAMES = [
  "Internal",
  "Client",
  "Sales_Partner",
  "Investor",
  "Trustee",
] as const;

export type UserRoleName = (typeof USER_ROLE_NAMES)[number];

export const ROLE_NAME_ALIASES: Record<string, UserRoleName> = {
  internal: "Internal",
  external: "Client",
  client: "Client",
  investor: "Investor",
  sales_partner: "Sales_Partner",
  trustee: "Trustee",
};
